import { isLocalhost } from "./isLocalhost";
const baseURL = {
    PRODUCTION_API_BASE_URL: 'https://internal-api.datadocs.com/v1',
    LOCAL_API_URL_TEMPLATE: 'http://HOST:7000/v1',
};
export function getServerAPIBaseURL() {
    return !isLocalhost
        ? baseURL.PRODUCTION_API_BASE_URL
        : baseURL.LOCAL_API_URL_TEMPLATE.replace("HOST", window.location.hostname);
}
/**
 * Check if a url is from datadocs subdomains
 * @param u url string
 * @returns
 */
export function isKnownDomain(url) {
    const subdomainRegex = isLocalhost ? /.*/ : /[^.\s]+\.datadocs\.com.*/;
    try {
        let u = new URL(url);
        return subdomainRegex.test(u.host);
    }
    catch (error) {
        return false;
    }
}
